import React from 'react';

function OrderSuccess({ title = 'SUCCESS', message = 'Your request has been received. We will contact you with delivery details shortly.', facilityAddress = null, onDone }) {
    return (
        <div className="min-h-[320px] flex items-center justify-center p-8">
            <div className="w-full max-w-sm bg-teal-500 rounded-lg shadow-lg text-white overflow-hidden">
                <div className="p-8 text-center">
                    <div className="w-20 h-20 bg-white/20 rounded-full mx-auto flex items-center justify-center mb-6">
                        <svg className="w-10 h-10 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                    </div>
                    <h2 className="text-2xl font-bold mb-2">{title}</h2>
                    <p className="text-sm opacity-90 mb-4">{message}</p>
                    {facilityAddress && (
                        <div className="bg-red-800 rounded-md p-3 text-left mb-4">
                            <p className="text-xs uppercase opacity-80">Pickup location</p>
                            <p className="font-semibold mt-1">{facilityAddress}</p>
                        </div>
                    )}
                    {/* Link at the extreme bottom */}
                    <div className="w-full max-w-sm mt-4 text-center">
                        <a href="/assessment" className="text-sm text-white hover:underline">Take a full HIV Risk Assessment</a>
                    </div>
                </div>

                <div className="bg-teal-600/90 p-4">
                    <button
                        onClick={onDone}
                        className="w-full bg-teal-700 hover:bg-teal-800 text-white font-semibold py-3 rounded-md transition-colors"
                    >
                        DONE
                    </button>
                </div>
            </div>
        </div>
    );
}

export default OrderSuccess;
